import * as XLSX from 'xlsx-js-style';

const HEADERS = [
  'Employee No.',
  'Date',
  'Activity Code',
  'Hours',
  'Department Dimension Code',
  'Project Dimension Code',
];

const toExcelDate = (value) => {
  if (!value) return '';
  const [year, month, day] = value.split('-').map(Number);
  return Math.floor(Date.UTC(year, month - 1, day) / 86400000) + 25569;
};

export const generateWeeklyWorkTimesExport = (records, fileName) => {
  const rows = (Array.isArray(records) ? records : []).map((item) => [
    item.employee_external_id ?? '',
    toExcelDate(item.date),
    item.type ?? '',
    item.hours ?? '',
    item.place_external_id ?? '',
    item.dimension_code ?? '',
  ]);
  const worksheet = XLSX.utils.aoa_to_sheet([HEADERS, ...rows]);

  // Keep dates as Excel dates and apply a readable date format.
  rows.forEach((row, index) => {
    const cell = worksheet[XLSX.utils.encode_cell({ r: index + 1, c: 1 })];
    if (cell && typeof row[1] === 'number') cell.z = 'm/d/yy';
  });

  worksheet['!cols'] = [
    { wch: 16 }, { wch: 12 }, { wch: 16 }, { wch: 10 }, { wch: 28 }, { wch: 24 },
  ];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Work Times');
  XLSX.writeFile(workbook, fileName);
};
